import PropTypes from "prop-types";
import Button from "@shared/v2/Button";
import SearchInput from "./form_controls/SearchInput";
import SuperUserRequests from "./SuperUserRequests";

const HeaderControls = ({ backUrl, onAddSuperUser, onSearch, roleOptions }) => (
  <div className="tw-flex tw-justify-between tw-items-center tw-gap-[16px]">
    <a href={backUrl}>Back</a>

    <div className="tw-flex tw-gap-[8px]">
      <Button size="medium" onClick={onAddSuperUser}>
        Add Super User
      </Button>

      <Button size="medium" onClick={() => SuperUserRequests.csvExport()}>
        Export All Super Users
      </Button>

      <SearchInput onSearch={onSearch} options={roleOptions} />
    </div>
  </div>
);

HeaderControls.propTypes = {
  backUrl: PropTypes.string.isRequired,
  onAddSuperUser: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  roleOptions: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default HeaderControls;
